import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*
 * Copyright 2020 New Relic Corporation. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
import { handle } from '../../../common/event-emitter/handle';
import { wrapHistory } from '../../../common/wrap/wrap-history';
import { wrapEvents } from '../../../common/wrap/wrap-events';
import { InstrumentBase } from '../../utils/instrument-base';
import * as CONSTANTS from '../constants';
import { FEATURE_NAMES } from '../../../loaders/features/features';
import { canEnableSessionTracking } from '../../utils/feature-gates';
import { now } from '../../../common/timing/now';
var BST_RESOURCE = CONSTANTS.BST_RESOURCE,
    RESOURCE = CONSTANTS.RESOURCE,
    START = CONSTANTS.START,
    END = CONSTANTS.END,
    FEATURE_NAME = CONSTANTS.FEATURE_NAME,
    FN_END = CONSTANTS.FN_END,
    FN_START = CONSTANTS.FN_START,
    PUSH_STATE = CONSTANTS.PUSH_STATE;
export var Instrument = /*#__PURE__*/function (_InstrumentBase) {
  _inherits(Instrument, _InstrumentBase);

  var _super = _createSuper(Instrument);

  function Instrument(agentRef) {
    var _this;

    var auto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _classCallCheck(this, Instrument);

    _this = _super.call(this, agentRef, FEATURE_NAME, auto);
    var canTrackSession = canEnableSessionTracking(_this.agentIdentifier);

    if (!canTrackSession) {
      _this.deregisterDrain();

      return _possibleConstructorReturn(_this);
    }

    var thisInstrumentEE = _this.ee;
    wrapHistory(thisInstrumentEE);
    _this.eventsEE = wrapEvents(thisInstrumentEE);

    _this.eventsEE.on(FN_START, function (args, target) {
      this.bstStart = now();
    });

    _this.eventsEE.on(FN_END, function (args, target) {
      // ISSUE: when target is XMLHttpRequest, nr@context should have params so we can calculate event origin
      // When ajax is disabled, this may fail without making ajax a dependency of session_trace
      handle('bst', [args[0], target, this.bstStart, now()], undefined, FEATURE_NAMES.sessionTrace, thisInstrumentEE);
    });

    thisInstrumentEE.on(PUSH_STATE + START, function (args) {
      this.time = now();
      this.startPath = location.pathname + location.hash;
    });
    thisInstrumentEE.on(PUSH_STATE + END, function (args) {
      handle('bstHist', [location.pathname + location.hash, this.startPath, this.time], undefined, FEATURE_NAMES.sessionTrace, thisInstrumentEE);
    });
    var observer;

    try {
      // Capture initial resources and watch for future ones. Don't defer this given there's a default cap on the number of buffered entries.
      observer = new PerformanceObserver(function (list) {
        // eslint-disable-line no-undef
        var entries = list.getEntries();
        handle(BST_RESOURCE, [entries], undefined, FEATURE_NAMES.sessionTrace, thisInstrumentEE);
      });
      observer.observe({
        type: RESOURCE,
        buffered: true
      });
    } catch (e) {// Per NEWRELIC-8525, we don't have a fallback for capturing resources for older versions that don't support PO at this time.
    }

    _this.importAggregator(agentRef, {
      resourceObserver: observer
    });

    return _this;
  }

  return _createClass(Instrument);
}(InstrumentBase);

_defineProperty(Instrument, "featureName", FEATURE_NAME);

export var SessionTrace = Instrument;